/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// Brand management

// Get list
// url: "/admin/auth/brand/index",
export function brandList(query) {
    return axios({
        url: "/brand/index",
        method: "get",
        params: query
    });
}
// Get role list
// url: "/admin/auth/admin/roleList",
export function brandRoleList(query) {
    return axios({
        url: "/admin/auth/admin/roleList",
        method: "get",
        params: query
    });
}
// save
// "/admin/auth/brand/save" :
// "/admin/auth/brand/edit";
export function brandSave(data, formName, method = "post") {
    let url =formName !== "Edit" ?
        "/brand/save" :
        "/brand/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// delete
// url: "/admin/auth/brand/delete",
export function brandDelete(data) {
    return axios({
        url: "/brand/delete",
        method: "post",
        data: data
    });
}

//Prefix Code add
export function savePrefixCode(data) {
    return axios({
        url: "/prefixcode/save",
        method: "post",
        data: data
    });
}

//Prefix Code query
export function queryPrefixCode(query) {
    return axios({
        url: "/prefixcode/index",
        method: "get",
        params: query
    });
}
//voucher
export function queryClient(query) {
    return axios({
        url: "/brand/client/index",
        method: "get",
        params: query
    });
}
//Create table
export function openData(data) {
    return axios({
        url: "/brand/open/data",
        method: "post",
        data: data
    });
}
